var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.9996,
    height: 18,
    fill: "#191A23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.859,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0114984 0.0204163C0.379613 0.0204163 0.747728 0.0204163 1.11584 0.0204163C1.14658 4.82372 1.11584 9.62647 1.02381 14.429C0.716991 15.0527 0.410296 15.6766 0.103527 16.3003C0.0114984 10.874 -0.0191656 5.44741 0.0114984 0.0204163Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66827 0.0202523C2.09013 -0.0276516 2.48898 0.0346609 2.86464 0.207377C2.98741 3.88756 2.98741 7.56755 2.86464 11.2477C2.45088 11.7769 2.08277 12.3383 1.7603 12.9319C1.66827 8.62837 1.63753 4.3245 1.66827 0.0202523Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32256 0.0202523C3.74442 -0.0276516 4.14328 0.0346609 4.51894 0.207377C4.6417 2.82712 4.6417 5.44687 4.51894 8.06662C4.10518 8.59581 3.73706 9.15718 3.41459 9.75074C3.32256 6.50787 3.29183 3.26443 3.32256 0.0202523Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.752,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39816 0.0201233C9.81229 -0.0395695 10.1804 0.0539929 10.5025 0.30081C7.33396 6.08802 4.23572 11.9201 1.2076 17.797C0.831943 17.9697 0.433182 18.032 0.0112305 17.9841C2.94676 11.8906 6.07574 5.90258 9.39816 0.0201233Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8708 0.0204098C11.3444 -0.0454581 11.7738 0.0481042 12.1592 0.301097C8.99069 6.0883 5.89245 11.9204 2.86434 17.7973C2.47064 18.0347 2.07197 18.0347 1.66797 17.7973C4.78719 11.8912 7.85488 5.96555 10.8708 0.0204098Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7112 0.0204098C13.1848 -0.0454581 13.6142 0.0481042 13.9996 0.301097C10.831 6.0883 7.73279 11.9204 4.70467 17.7973C4.32901 17.97 3.93016 18.0323 3.5083 17.9844C3.55524 17.5136 3.70874 17.0768 3.96844 16.6745C6.9787 11.1775 9.89288 5.62611 12.7112 0.0204098Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58256 9.75098C11.0966 12.3913 12.5691 15.0734 13.9999 17.7973C13.5335 18.0363 13.0734 18.0363 12.6195 17.7973C11.4539 15.5518 10.288 13.3063 9.12241 11.0608C9.06407 10.5543 9.21739 10.1177 9.58256 9.75098Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66166 11.4351C8.91658 11.636 9.13119 11.8855 9.30586 12.1836C10.2939 14.0316 11.2449 15.9028 12.1588 17.7973C11.8052 18.0108 11.4371 18.0421 11.0544 17.8909C10.1415 16.253 9.25175 14.5999 8.38558 12.9321C8.25342 12.3881 8.34545 11.889 8.66166 11.4351Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.714,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74169 13.1193C8.09747 13.333 8.37355 13.6447 8.56994 14.0549C9.16721 15.3318 9.81141 16.5794 10.5025 17.7974C10.0731 18.0468 9.64355 18.0468 9.21415 17.7974C8.67817 16.6451 8.09526 15.5223 7.4656 14.4291C7.35351 13.9492 7.44554 13.5124 7.74169 13.1193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogo);
export default __webpack_public_path__ + "static/media/kLogo.fc46a3fc3420d1df0abb6a32e81b5a49.svg";
export { ForwardRef as ReactComponent };